import React from 'react';
import { useQuery, gql } from '@apollo/client';
import apolloClient from '../lib/apolloClient';
import CatastropheTile from '../components/Succession/CatastropheTile';

const GET_CATASTROPHE_TILE_DATA = gql`
  query GetCatastropheTileData {
    catastropheFormDatum {
      id
      status
      currentSection
      currentSectionName
      completionPercentage
    }
    getCurrentUser {
      id
      has_legacy_catastrophic_plan
      legacy_catastrophic_plan_status
      last_catastrophic_plan_downloaded_date
      company {
        id
        features
        business_type
        affiliate_name
      }
    }
    mySuccessionPlans {
      id
      status
      completionPercentage
      planTemplate {
        id
        planType
      }
    }
  }
`;

const CatastropheTileContainer = () => {
  const { loading, error, data } = useQuery(GET_CATASTROPHE_TILE_DATA, { client: apolloClient });

  if (loading) return <CatastropheTile />;
  if (error) return <CatastropheTile />;

  const currentUser = data?.getCurrentUser;
  const isRj = currentUser?.company?.business_type === 'wealth_rj';
  const catastrophicPlan = data?.mySuccessionPlans?.find(p => p.planTemplate?.planType === 'catastrophic');
  const catPlanFilesUnavailable = currentUser?.company?.features?.includes('catastrophic_plans_files_unavailable');

  const shareTemplates = currentUser?.company?.features?.includes('share_transactional_legal_templates');
  const affiliateName = currentUser?.company?.affiliate_name;
  let templateInfo = null;
  if (shareTemplates) {
    if (affiliateName === 'RJA') {
      templateInfo = {
        url: 'https://findbob-production.s3-us-west-2.amazonaws.com/rj/Template+Agreements/RJA+Agreements/Commitment+Agreement+Template+-+RJA.pdf',
        fileName: 'Commitment Agreement Template - RJA.pdf',
        label: 'Download Commitment Agreement Template',
      };
    } else if (affiliateName === 'ICD') {
      templateInfo = {
        url: 'https://findbob-production.s3-us-west-2.amazonaws.com/rj/Template+Agreements/ICD+Agreements/Sample+Catastrophic+Plan+Template+(ICD).pdf',
        fileName: 'Sample Catastrophic Plan Template (ICD).pdf',
        label: 'Download Catastrophic Succession Plan Template',
      };
    } else {
      templateInfo = {
        url: 'https://findbob-production.s3-us-west-2.amazonaws.com/resources/Business+Continuity+Agreement+Template+v1.1.docx',
        fileName: 'Business Continuity Agreement Template v1.1.docx',
        label: 'Download Agreement Template',
      };
    }
  }

  return (
    <CatastropheTile
      catastropheData={data?.catastropheFormDatum}
      catastrophicPlan={catastrophicPlan}
      isRj={isRj}
      legacyCatPlanStatus={currentUser?.legacy_catastrophic_plan_status}
      lastCatPlanDownloadedDate={currentUser?.last_catastrophic_plan_downloaded_date}
      catPlanFilesUnavailable={catPlanFilesUnavailable}
      templateInfo={templateInfo}
    />
  );
};

export default CatastropheTileContainer; 